(function () {
  'use strict';

  if (window.MBIJudgeMeCarouselDragLoaded) return;
  window.MBIJudgeMeCarouselDragLoaded = true;

  var ROOT_SELECTOR =
    '.mbi-flexible-app-section--testimonial[data-mbi-testimonial-drag="true"] .jdgm-cards-carousel';
  var DRAG_THRESHOLD = 7;

  function translateX(element) {
    var transform = window.getComputedStyle(element).transform;
    var values;

    if (!transform || transform === 'none') return 0;

    values = transform.match(/^matrix3d\((.+)\)$/);
    if (values) return parseFloat(values[1].split(',')[12]) || 0;

    values = transform.match(/^matrix\((.+)\)$/);
    if (values) return parseFloat(values[1].split(',')[4]) || 0;

    return 0;
  }

  function cardStep(track) {
    var card = track.querySelector('.jdgm-carousel-item:not(.jdgm-clone-before):not(.jdgm-clone-after)');
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;

    return card ? card.getBoundingClientRect().width + gap : 0;
  }

  function initialise(root) {
    var viewport = root.querySelector('.jdgm-cards-wrapper');
    var track = root.querySelector('.jdgm-videos-container');
    var previous = root.querySelector('[aria-label="Previous slide"]');
    var next = root.querySelector('[aria-label="Next slide"]');

    if (!viewport || !track || viewport.dataset.mbiDragReady === 'true') return;

    viewport.dataset.mbiDragReady = 'true';

    var state = {
      active: false,
      moved: false,
      pointerId: null,
      startX: 0,
      lastX: 0,
      lastTime: 0,
      velocity: 0,
      startTranslate: 0,
      originalTransform: '',
      originalTransition: '',
      frame: 0,
      pendingX: 0,
      suppressClick: false
    };

    function paint() {
      state.frame = 0;
      track.style.transform = 'translate3d(' + state.pendingX + 'px, 0, 0)';
    }

    function queuePaint(x) {
      state.pendingX = x;
      if (!state.frame) state.frame = window.requestAnimationFrame(paint);
    }

    function restoreTrack() {
      if (state.frame) {
        window.cancelAnimationFrame(state.frame);
        state.frame = 0;
      }

      track.style.transition = state.originalTransition;
      track.style.transform = state.originalTransform;
    }

    function finish(event, cancelled) {
      if (!state.active || event.pointerId !== state.pointerId) return;

      var delta = event.clientX - state.startX;
      var step = cardStep(track);
      var projected = delta + state.velocity * 160;
      var threshold = step ? Math.min(72, step * 0.22) : 48;
      var control = projected < 0 ? next : previous;

      state.active = false;
      viewport.classList.remove('mbi-is-dragging');

      if (state.moved) {
        state.suppressClick = true;
        window.setTimeout(function () {
          state.suppressClick = false;
        }, 400);
      }

      try {
        viewport.releasePointerCapture(state.pointerId);
      } catch (error) {
        /* Pointer capture may already have been released by the browser. */
      }

      if (!cancelled && state.moved && Math.abs(projected) >= threshold && control) {
        if (state.frame) {
          window.cancelAnimationFrame(state.frame);
          state.frame = 0;
        }

        track.style.transition = state.originalTransition;
        var draggedTransform = track.style.transform;
        control.click();

        window.setTimeout(function () {
          if (track.style.transform === draggedTransform) {
            track.style.transition = state.originalTransition;
            track.style.transform = state.originalTransform;
          }
        }, 100);
      } else {
        track.style.transition = 'transform 320ms cubic-bezier(0.22, 0.61, 0.36, 1)';
        track.style.transform = state.originalTransform;

        window.setTimeout(function () {
          track.style.transition = state.originalTransition;
        }, 340);
      }

      state.pointerId = null;
    }

    viewport.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (event.target.closest('button, input, select, textarea')) return;

      state.active = true;
      state.moved = false;
      state.pointerId = event.pointerId;
      state.startX = event.clientX;
      state.lastX = event.clientX;
      state.lastTime = event.timeStamp;
      state.velocity = 0;
      state.startTranslate = translateX(track);
      state.originalTransform = track.style.transform;
      state.originalTransition = track.style.transition;
      state.pendingX = state.startTranslate;

      track.style.transition = 'none';
      viewport.setPointerCapture(event.pointerId);
      viewport.classList.add('mbi-is-dragging');
    });

    viewport.addEventListener('pointermove', function (event) {
      if (!state.active || event.pointerId !== state.pointerId) return;

      var delta = event.clientX - state.startX;
      var elapsed = Math.max(1, event.timeStamp - state.lastTime);

      if (!state.moved && Math.abs(delta) < DRAG_THRESHOLD) return;

      state.moved = true;
      state.velocity = (event.clientX - state.lastX) / elapsed;
      state.lastX = event.clientX;
      state.lastTime = event.timeStamp;

      event.preventDefault();
      queuePaint(state.startTranslate + delta);
    });

    viewport.addEventListener('pointerup', function (event) {
      finish(event, false);
    });

    viewport.addEventListener('pointercancel', function (event) {
      finish(event, true);
    });

    viewport.addEventListener(
      'click',
      function (event) {
        if (!state.suppressClick) return;

        state.suppressClick = false;
        event.preventDefault();
        event.stopImmediatePropagation();
      },
      true
    );
  }

  function scan(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    container.querySelectorAll(ROOT_SELECTOR).forEach(initialise);

    if (container.matches && container.matches(ROOT_SELECTOR)) initialise(container);
  }

  function start() {
    scan(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) scan(node);
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    document.addEventListener('shopify:section:load', function (event) {
      scan(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
